import IconComponent from "icons/IconComponent";

import CollapseIcon from "./collapse.svg";

export default (CollapseIcon as any) as IconComponent;
